import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const Completado = (reporte) => {
  const navigate = useNavigate();

  useEffect(() => {
    let time = 15;
    let interval = setInterval(() => {
      time = time - 1;
      document.getElementById("time-redireccion").innerHTML = time;
      if (time == 0) {
        clearInterval(interval);
        navigate('/?ofEntradas=on');
      }
    }, 1000);
  }, []);
  return (
    <div className="container-md min-vh-100 py-5">
      <div className="py-5">
        <img
          src="/assets/img/marca/antesala-logo.svg"
          className="mb-5"
          width="200px"
          alt=""
        />
        <h2 className="GothamBold fs-3">Gracias por tu compra!</h2>
        <h2 className="GothamBold fs-3">Su pago se completo con exito</h2>
        <span className="GothamBold mb-2 d-block">
          Le enviaremos un correo electronico con las entradas y un codigo de
          aprobación. por favor no comparta el codigo de entrada con ninguna
          otra persona.
        </span>
        <span className="GothamBold mb-2 d-block">
          Si no recibe las entradas en su correo puede descargarlas directamente desde su perfil. <Link to="/?ofEntradas=on">VER ENTRADAS</Link>
        </span>
      </div>
      <span className="GothamBold fs-4">
        <i className="bi bi-arrow-90deg-left me-1"></i> Se rediccionara a la web
        principal en
        <span className="ms-2" id="time-redireccion"></span>
      </span>
    </div>
  );
};

export default Completado;
